/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowdescriptionnext3Inputs */

const en_aiflowdescriptionnext3 = /** @type {(inputs: Aiflowdescriptionnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looks good`)
};

const de_aiflowdescriptionnext3 = /** @type {(inputs: Aiflowdescriptionnext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passt so`)
};

/**
* | output |
* | --- |
* | "Looks good" |
*
* @param {Aiflowdescriptionnext3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowdescriptionnext3 = /** @type {((inputs?: Aiflowdescriptionnext3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowdescriptionnext3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowdescriptionnext3(inputs)
	return de_aiflowdescriptionnext3(inputs)
});
export { aiflowdescriptionnext3 as "aiFlowDescriptionNext" }